import {
  Output,
  EventEmitter,
  Component,
  OnInit,
  Injector,
  Input,
  ElementRef,
  ViewContainerRef,
  ViewChild,
  OnChanges
} from "@angular/core";
import { BaseComponent } from "../../base.component";
import { isEmpty } from "lodash";
import { UnMaskedComponent } from "../unmasked-input/unmasked-input.component";

@Component({
  selector: "popover-address",
  template: `
    <div
      class="popover"
      aria-describedby="confirm-address"
      *ngIf="suggestedOnInit"
    >
      <div class="popover-inner">
        <i
          role="button"
          aria-label="Close"
          (keyup)="closePopOver($event)"
          tabindex="0"
          class="icon icon-close"
          (click)="onClose()"
        ></i>
        <div
          id="confirm-address"
          class="popover-title"
          *ngIf="!isEmpty(addresses)">
          {{getTitle()}}
        </div>
        <div class="popover-content">
          <ul role="list">
            <li
              role="listitem"
              tabindex="0"
              (keyup)="eventHandler($event, address)"
              class="linkable"
              [hidden]="isEmpty(addresses)"
              *ngFor="let address of addresses"
              (click)="onSelect(address)"
            >
              {{ address.FullName }}
            </li>
            <li role="listitem" tabindex="-1" *ngIf="isEmpty(addresses)">
              No match was found.
            </li>
          </ul>
        </div>
      </div>
    </div>
  `,
  styleUrls: ["./popover-address.component.scss"],
  providers: [UnMaskedComponent]
})
export class PopoverAddressComponent extends BaseComponent implements OnInit {
  @Output() onAddressSelect: EventEmitter<any> = new EventEmitter();
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Input() addresses: any;
  @Input() changeTitle: boolean;
  @Input() isOpen: boolean;
  @Input() suggestedOnInit: boolean;

  constructor(injector: Injector, private unmaskedInput: UnMaskedComponent) {
    super(injector);
  }

  ngOnInit() {
    // this.isOpen = false;
  }

  isEmpty(obj) {
    return isEmpty(obj);
  }

  getTitle(){
    if(this.changeTitle)
      return "Is this your address?";
    else return "Is This Your Address?";
  }
  
  onSelect(address: any) {
    document
      .getElementsByClassName("address-line1-input")[0]
      .removeEventListener("blur", () => {});
    this.close.emit();
    this.onAddressSelect.emit({ address });
    document
      .getElementsByClassName("address-line1-input")[0]
      .addEventListener("blur", this.unmaskedInput.onBlur);
  }

  onClose() {
    this.close.emit();
    //this.addresses = Object.assign({}, this.addresses);
  }

  eventHandler(event, address: any) {
    // if "Enter" key pressed
    if (event.keyCode === 13) {
      this.onSelect(address);
    }
  }

  closePopOver(event) {
    // if "Enter" or "Space" pressed
    if (event.keyCode === 13 || event.keyCode === 32) {
      this.onClose();
    }
  }
}
